module.exports = __webpack_public_path__ + "img/publishpopup.bc95e4c.png";